export default function (guid, withThankYou = false) {
  return `<script type="text/javascript">(function(formGuid, withThankYou){document.write('<div data-form-guid="'+formGuid+'" data-thank-you="'+withThankYou+'"></div>');const script = document.createElement('script');script.src = 'https://${PUBLIC_DOMAIN}/app.js';document.head.appendChild(script);})('${guid}', ${withThankYou});</script>`;
}
